import React, { useState, useEffect } from 'react';
import '../Challenges/challenges.css';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import Swal from 'sweetalert2';
import { FiChevronDown,FiRefreshCw  } from 'react-icons/fi';

const BlockCourt = () => {
  const { userData } = useUser();
  const { selectedCenter, setSelectedCenter } = useUser();
  const [searchTerm, setSearchTerm] = useState('');
  const [BlockCourt, setBlockCourt] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem('auth-token');

    const fetchBlockCourtList = async () => {
      setLoading(true);
      setError('')
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_COURT_BLOCK_LIST}?academyId=${selectedCenter}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );
        if (response.data.success && response.data.data?.courtBlockList) {
          const { courtBlockList: fetchedBlockCourtList } = response.data.data;
          const formatDate = (date) => {
            const d = new Date(date);
            return d.toLocaleDateString();
          };
          const formattedBlockCourtList = fetchedBlockCourtList.map((block) => ({
            id: block.id,
            courtName: block?.academyCourtEntity?.name || 'N/A',
            startDate: block?.startDate ? formatDate(block.startDate) : 'N/A',
            endDate: block?.endDate ? formatDate(block.endDate) : 'N/A',
            startTime: block?.startTime || 'N/A',
            endTime: block?.endTime || 'N/A',
            weekDays: block?.weekDays || 'N/A',
            remark: block?.remark || '-',
          }));

          setBlockCourt(formattedBlockCourtList);
        }
        else {
        }
      } catch (err) {
        setError('Error fetching data: ' + error.message);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
    if (selectedCenter) {
      fetchBlockCourtList();
    }
  }, [selectedCenter]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  const headers = [
    { label: "Court Name", key: "courtName" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Start Time", key: "startTime" },
    { label: "End Time", key: "endTime" },
    { label: "Week Days", key: "weekDays" },
    { label: "Remark", key: "remark" },
  ];

  const [editedChallenge, setEditedChallenge] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredBlockCourt = BlockCourt.filter((Court) =>
    Object.values(Court)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedChallenge((prevChallenge) => ({
      ...prevChallenge,
      [name]: value,
    }));
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });

  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };

  const sortedData = sortData(filteredBlockCourt);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleDelete = async (courtId) => {
    if (!courtId) {
      alert('Please provide a court ID.');
      return;
    }

    const isConfirmed = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this court?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    });

    if (!isConfirmed.isConfirmed) {
      return;
    }


    const updatedCourts = BlockCourt.filter(court => court.id !== courtId);
    setBlockCourt(updatedCourts);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_DELETE_COURT_BLOCK}?academyId=${selectedCenter}&id=${courtId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorData.success_message || "Unknown error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        setBlockCourt(prevCourts => [...prevCourts]);
        return;
      }

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Court deleted successfully!",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to delete court",
          text: data.success_message || "Unknown error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        setBlockCourt(prevCourts => [...prevCourts]);
      }
    } catch (err) {
      setBlockCourt(prevCourts => [...prevCourts]);
    }
  };

  const totalEntries = filteredBlockCourt.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  const getWeekdayDistribution = () => {
    const weekdayOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const weekdayColors = {
      Sun: '#FF6384',
      Mon: '#36A2EB',
      Tue: '#FFCE56',
      Wed: '#4BC0C0',
      Thu: '#9966FF',
      Fri: '#FF9F40',
      Sat: '#00D084'
    };

    const weekdayData = BlockCourt.reduce((acc, court) => {
      if (court.weekDays && court.weekDays !== 'N/A') {
        let days = court.weekDays.split(',').map(d => d.trim());

        const dayMapping = {
          Monday: 'Mon', Tuesday: 'Tue', Wednesday: 'Wed',
          Thursday: 'Thu', Friday: 'Fri', Saturday: 'Sat', Sunday: 'Sun'
        };
        days = days.map(d => dayMapping[d] || d);

        days.forEach(day => {
          if (!acc[day]) acc[day] = { count: 0, details: [] };
          acc[day].count++;
          acc[day].details.push({
            courtName: court.courtName,
            startDate: court.startDate,
            endDate: court.endDate,
            startTime: court.startTime,
            endTime: court.endTime
          });
        });
      }
      return acc;
    }, {});

    const sortedLabels = weekdayOrder.filter(day => weekdayData[day]);
    const counts = sortedLabels.map(day => weekdayData[day].count);
    const details = sortedLabels.map(day => weekdayData[day].details);
    const backgroundColors = sortedLabels.map(day => weekdayColors[day]);

    return {
      labels: sortedLabels,
      datasets: [{
        label: 'Number of Blocks',
        data: counts,
        details: details,
        backgroundColor: backgroundColors,
        borderColor: backgroundColors,
        borderWidth: 1
      }]
    };
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: true, text: 'Court Block' },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => `Weekday: ${tooltipItems[0].label}`,
          label: (context) => {
            const dataset = context.dataset;
            const details = dataset.details && dataset.details[context.dataIndex];
            if (!details) return [];

            return details.map(block => (
              `${block.courtName}\n`
            ));
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 }
      }
    }
  };

  return (
    <div className="enrollment-container">
      {/* {getWeekdayDistribution()?.datasets?.[0]?.data?.length > 0 && (
        <div className="chart-container-court">
          <Bar
            data={getWeekdayDistribution()}
            options={chartOptions}
          />
        </div>
      )} */}

      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
      </div>
      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchBlockCourtList}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredBlockCourt.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
              {hasPrivilege(userData, 'COURTS', 'BLOCK_COURT_LIST_MODIFY') && (
                <th>Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((Court) => (
              <tr key={Court.id}>
                <td>{Court.courtName}</td>
                <td>{Court.startDate}</td>
                <td>{Court.endDate}</td>
                <td>{Court.startTime}</td>
                <td>{Court.endTime}</td>
                <td>{Court.weekDays}</td>
                <td>{Court.remark}</td>
                {hasPrivilege(userData, 'COURTS', 'BLOCK_COURT_LIST_MODIFY') && (
                <td>
                  <button className="delete-button" onClick={() => handleDelete(Court.id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                    </svg>
                  </button>
                </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default BlockCourt;
